<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="16" width="1" height="1" fill="currentColor" />
    <rect x="6" y="16" width="1" height="1" fill="currentColor" />
    <rect x="2" y="12" width="1" height="1" fill="currentColor" />
    <rect x="2" y="14" width="1" height="1" fill="currentColor" />
    <rect x="8" y="14" width="1" height="1" fill="currentColor" />
    <rect x="8" y="12" width="1" height="1" fill="currentColor" />
    <rect x="5" y="17" width="1" height="1" fill="currentColor" />
    <rect x="3" y="15" width="1" height="1" fill="currentColor" />
    <rect x="3" y="11" width="1" height="1" fill="currentColor" />
    <rect x="4" y="10" width="1" height="1" fill="currentColor" />
    <rect x="7" y="15" width="1" height="1" fill="currentColor" />
    <rect x="7" y="11" width="1" height="1" fill="currentColor" />
    <rect x="6" y="10" width="1" height="1" fill="currentColor" />
    <circle cx="14" cy="14" r="3.5" stroke="currentColor" />
    <path d="M2 5.5H9" stroke="currentColor" stroke-linejoin="bevel" />
    <path d="M5.5 2L5.5 9" stroke="currentColor" stroke-linejoin="bevel" />
    <rect x="11" y="2.5" width="6" height="6" stroke="currentColor" />
  </svg>
</template>
